import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const { lang, t } = useApp();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await api.post("/admin/login", form);
            localStorage.setItem("sraa_admin_token", r.data.token);
            toast.success(lang === "ar" ? "مرحبًا بك" : "Welcome");
            navigate("/admin");
        } catch (err) {
            toast.error(lang === "ar" ? "بيانات خاطئة" : "Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="pt-32 pb-24 min-h-[80vh] flex items-center">
            <div className="max-w-md w-full mx-auto px-6">
                <div className="overline mb-3 text-center">{lang === "ar" ? "المسؤول فقط" : "Admin Only"}</div>
                <h1 className="section-heading text-4xl text-white text-center mb-10">{t.admin.login}</h1>
                <form onSubmit={submit} className="luxury-card p-8 space-y-4">
                    <input
                        required
                        type="email"
                        placeholder={t.checkout.email}
                        data-testid="admin-email-input"
                        className="lux-input"
                        value={form.email}
                        onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                    />
                    <input
                        required
                        type="password"
                        placeholder={lang === "ar" ? "كلمة المرور" : "Password"}
                        data-testid="admin-password-input"
                        className="lux-input"
                        value={form.password}
                        onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                    />
                    <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-gold btn-gold-filled w-full">
                        {loading ? "..." : t.admin.login}
                    </button>
                </form>
            </div>
        </div>
    );
}
